<template>
    <div></div>
</template>

<script>
import * as Sentry from '@sentry/vue'

import api from '@/api'
import { bootRequestsSettled } from '@/boot-requests'
import bus from '@/bus'

export default {
    data() {
        return {
        }
    },
    mounted() {
        const challenge_key = this.$route.params.challengeKey
        const secure_token = this.$route.params.secureToken

        let new_device_id = this.$route.query.new_device_id || ''

        this.$store.dispatch('SET_PAGE_TITLE', 'Logging in...')
        this.$store.dispatch('START_LOADING')
        this.$store.dispatch('SET_IS_IN_APP', true)
        // Not until App.vue's boot requests have answered. Sent alongside them,
        // the exchange can be answered first, and a boot response landing
        // behind it overwrites the session cookie it just set: /me then gets a
        // 401 and the user, who signed in correctly, lands on the login page
        // (production, 2026-10-08). See boot-requests.js.
        let boot_wait = 'pending'

        // The user is about to land on the login form, having signed in
        // correctly in the native app, and that app can only see that it
        // happened. What failed is known here and nowhere else: `stage` is the
        // request that was refused, and the status tells a spent or expired
        // token (404) from a session that did not survive (401) from a request
        // that never arrived ('none'). A message, not the rejection itself:
        // sentry.js drops every 401 it is handed, and this one is the point.
        const reportFailure = (stage, errors) => {
            const status = errors && errors.__status__ !== undefined ? String(errors.__status__) : 'none'
            Sentry.captureMessage('Auto-login failed', {
                level: 'error',
                tags: {
                    'auto_login.stage': stage,
                    'auto_login.status': status,
                    'auto_login.boot_wait': boot_wait,
                },
                fingerprint: ['auto-login', stage, status],
                extra: { ms_since_page_load: Math.round(performance.now()) },
            })
        }

        bootRequestsSettled().then((outcome) => {
            boot_wait = outcome
            return api.post(`/login/complete/get-session/${challenge_key}/${secure_token}`, {
                'new_device_id': new_device_id,
            })
        }).then(resp => {
            this.$store.dispatch('SET_SESSION', resp)
            this.$store.dispatch('GET_USER').then(user_resp => {
                this.$store.dispatch('STOP_LOADING')

                // replace, here and below: left in the history, this page is
                // one Android back press away, and it would exchange the
                // token again.
                if (resp['prompt_review_trusted_devices']) {
                    if (new_device_id) {
                        this.$router.replace({name: 'review-trusted-devices', query: {ndid: new_device_id}})
                    } else {
                        this.$router.replace({name: 'review-trusted-devices'})
                    }
                } else {
                    this.$router.replace({name: 'index'})
                }
            }).catch(errors => {
                reportFailure('user', errors)
                this.$store.dispatch('STOP_LOADING')
                bus.showError(errors.__all__)
                this.$router.replace({name: 'login'})
            })
        }).catch(errors => {
            reportFailure('exchange', errors)
            this.$store.dispatch('STOP_LOADING')
            bus.showError(errors.__all__)
            this.$router.replace({name: 'login'})
        })
    },
}
</script>
